import { BooleanField, Datagrid, FunctionField, Identifier, InfiniteList, RaRecord, TextField, useRefresh } from 'react-admin'
import SetToDefaultDialog from './SetToDefaultDialog'
import { useState } from 'react'
import NumberRangeFilters from './NumberRangeFilters'
import { NumberRangeReadModel } from '../GeneratedClients/FreeBillApi'
import { HubConnection } from '@microsoft/signalr'
import NumberRangeListActions from './NumberRangeListActions'

interface IProps {
  connection?: HubConnection
}

const NumberRangeList = ({connection}: IProps) => {

  const [record, setRecord] = useState<RaRecord>()
  const refresh = useRefresh()

  const isUsed = (firstNumber?: number, nextNumber?: number) => {
    return firstNumber !== nextNumber
  }

  const handleRowClick = (id:Identifier, resource: string, record: RaRecord) => {
    record.isDefault === false && setRecord(record)
    return isUsed(record.firstNumber, record.nextNumber) ? "" : "edit"
  }

  connection?.on('NumberRangeUpdated', (numberRange) => {refresh()})
  connection?.on('NumberRangeDefaultUpdated', () => {refresh()})

  return (
    <>
      <InfiniteList filters={NumberRangeFilters} actions={<NumberRangeListActions />} sort={{field: "name", order: "ASC"}} >
        <Datagrid rowClick={handleRowClick} bulkActionButtons={false} >
          <TextField source="name" label="resources.numberRanges.title" sortable={false} />
          <FunctionField render={(numberRange: NumberRangeReadModel) => `${numberRange.value}${numberRange.nextNumber}`} label="resources.numberRanges.nextNumber" sortable={false} />
          <BooleanField source="isDefault" label="resources.numberRanges.isDefault" sortable={false} />
          <FunctionField 
            render={(numberRange: NumberRangeReadModel) => <BooleanField record={{isUsed: isUsed(numberRange.firstNumber, numberRange.nextNumber)}} source='isUsed' />}
            label="resources.numberRanges.isUsed" 
            sortable={false}
          />
        </Datagrid>
      </InfiniteList>
      <SetToDefaultDialog record={record} setRecord={setRecord} />
    </>
  )
}

export default NumberRangeList